<template>
  <div class="mine-content" v-if="!!userInfo">
    <div class="mine-header">Profile</div>
    <div class="first-pard">
      <div class="avater" @click="util.topage('/avater')">
        <img :src="userInfo.ico_picture_img" />
        <!-- <div>{{ userInfo.nick_name }}</div> -->
        <div class="level">V{{userInfo.vip_level}}</div>
      </div>
      <div class="account">
        <div>
          Username: {{ userInfo.phone }}
          <button v-clipboard:error="util.onError" v-clipboard:copy="userInfo.phone" v-clipboard:success="util.onCopy">Copy</button>
        </div>
        <!-- <div>
          Email: {{ userInfo.email }}
          <button v-clipboard:error="util.onError" v-clipboard:copy="userInfo.email" v-clipboard:success="util.onCopy">Copy</button>
        </div> -->
        <!-- <div>
          Invitation code: {{ userInfo.invite_code }}
          <button v-clipboard:error="util.onError" v-clipboard:copy="(userInfo.invite_code).toString()" v-clipboard:success="util.onCopy">Copy</button>
        </div> -->
        <div class="money">
          <div>
            <div>Real Balance: {{ banlance }}</div>
            <div>Frozen Amount: {{ frozen }}</div>
            <div>Credit Score: {{ integral }}</div>
          </div>
          <div class="eyeimg cursor" @click="fristeye()"><img :src="fristeyepic" /></div>
        </div>
      </div>
    </div>
    <div class="four-pard">
      <button class="btn" @click="util.topage('/recharge')">Recharge</button>
      <button class="btn" @click="util.topage('/withdraw')">Withdraw</button>
    </div>
    <div class="second-pard">
      <ul @click="util.topage('/personal')">
        <li><img src="@/assets/images/user/info/ic_personal.png" /></li>
        <li>Personals</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul>
      <ul @click="util.topage('/wallet')">
        <li><img src="@/assets/images/user/info/ic_wallet.png" /></li>
        <li>My Wallets</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul>
      <ul @click="util.topage('/security')">
        <li><img src="@/assets/images/user/info/ic_shield.png" /></li>
        <li>Security Settings</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul>
      <ul @click="util.topage('/sitedigital')">
        <li><img src="@/assets/images/user/info/ic_digital.png" /></li>
        <li>Platform Wallet</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul>
      <ul @click="util.topage('/notice')">
        <li><img src="@/assets/images/user/info/ic_notice.png" /></li>
        <li>Site Notifications</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul>
      <ul @click="util.topage('/mymsg')">
        <li><img src="@/assets/images/user/info/ic_msg.png" /></li>
        <li>Site Messages</li>
        <li><div v-if="newMessage>0" style="color:red;">●●●</div><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul>
      <!-- <ul v-if="telegram_url.length > 1" @click="to_service('telegram')">
        <li><img src="@/assets/images/base/img_tg.png" alt=""></li>
        <li>Online Telegram</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul> -->
      <ul @click="util.topage('/about')">
        <li><img src="@/assets/images/user/info/ic_about.png" /></li>
        <li>About Company</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul>
      <ul v-if="telegram_url.length > 1">
        <li><img src="@/assets/images/base/img_tg.png" alt=""></li>
        <li>
          <!-- <a href="https://t.me/CustomerSupportTeaV_001" target="_blank" style="color: #555;">Click Here Contact Our Online Service</a> -->
          <a :href="telegram_url" target="_blank" style="color: #555;">Click Here Contact Our Online Service</a>
        </li>
        <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
		  </ul>
      <ul v-if="whatsapp_url.length > 1" @click="to_service('whatsapp')">
        <li><img src="@/assets/images/base/img_wa.png" alt=""></li>
        <li>Online WhatsApp</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul>
      <!-- <ul @click="util.topage('/invite')">
        <li><img src="@/assets/images/user/info/ic_friend.png" /></li>
        <li>Invite Friends</li>
        <li><img src="@/assets/images/base/icon_righ_g.png" /></li>
      </ul> -->
    </div>
    <div class="third-part"><button class="btn" @click="logOut();">Exit</button></div>
    <FootMenu />
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import FootMenu from "@/coms/footmenu.vue";
export default {
  components: {
    FootMenu
  },
  data() {
    return {
      showloding: false,
      userInfo: this.util.user,
      banlance: '***',
      frozen: '***',
      integral: '***',
      newMessage:0,
      fristeyepic: require("@/assets/images/icon/show_eye_icon_251206.png"),
      telegram_url: '',
      whatsapp_url: ''
    };
  },
  methods: {
    to_service(url) {
      if(url == 'telegram') {
        window.location.href = this.telegram_url
      } else {
        window.location.href = this.whatsapp_url
      }
    },
    get_service_url() {
      this.axios.get(this.api.api_findConfigs, {
        params: {
          names: "telegram,whatsapp",
        },
      }).then((res) => {
        this.telegram_url = res.data.data.telegram
        this.whatsapp_url = res.data.data.whatsapp
      })
        .catch((err) => {
          console.log(err);
        });
    },
    fristeye() {
      if (this.banlance == "***") {
        this.refreshMoney();
        this.userInfo = this.util.user;
        this.banlance = this.userInfo.money;
        this.frozen = this.userInfo.frozen_money;
        this.integral = this.userInfo.integral;
        this.fristeyepic = require("@/assets/images/icon/show_eye_icon_251206.png");
      } else {
        this.banlance = "***";
        this.frozen = "***";
        this.integral = "***";
        this.fristeyepic = require("@/assets/images/icon/hide_eye_icon_251206.png");
      }
    },
    refreshMoney() {
      this.util.refreshUserInfo((res) => {
        this.userInfo = res;
        if (this.banlance != "***") {
          this.banlance = this.userInfo.money;
          this.frozen = this.userInfo.frozen_money;
        }
      });
    },
    logOut() {
      this.util.outline();
      sessionStorage.removeItem("user");
      this.util.topage('login');
    },
    getNotReadCount() {
        let params = {};
        this.util.setDnValueUser(params);
        this.axios.get(this.api.api_getNotReadCount, {params: params}).then(res => {
          if(res.data.flag){
            this.newMessage = res.data.data;    
          }
        });
    },
  },
  mounted() {
    this.get_service_url()
  },
  activated() {
    if (!this.util.isLogin()) this.util.topage('login');
    this.util.refreshUserInfo((res) => {
      this.userInfo = res;
      this.banlance = this.userInfo.money;
      this.frozen = this.userInfo.frozen_money;
      this.integral = this.userInfo.integral;
      this.getNotReadCount();
    });
  }
};
</script>
<style lang="scss" scoped>
.mine-content {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  font-size: 0.32rem;
  background: rgb(235, 235, 235);
  width: 100%;
  height: 100%;

  .mine-header {
    background: rgb(235, 235, 235);
    height: 36px;
    font-size: 0.36rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: black;
    border-bottom: 1px solid white;
  }

  .first-pard {
    font-size: 0.31rem;
    height: 3.8rem;
    display: flex;
    align-items: center;
    background-color: white;

    //border-bottom: 1px solid white;
    .avater {
      margin-top: 0.35rem;
      font-weight: bold;
      text-align: center;
      color: brown;
      margin-right: 5px;
      position: relative;

      .level {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 0;
        right: 0;
        background: #628808;
        border-radius: 50%;
        color: #fff;
      }

      img {
        border-radius: 100%;
        border: 0.08rem solid #628808;
        display: block;
        margin: auto 0.1rem;
        width: 2.6rem;
      }
    }

    .account {
      width: 80%;

      input {
        max-width: 4rem;
      }

      button {
        color: brown;
        float: right;
        padding-right: 0.2rem;
      }

      .money {
        display: flex;
        margin-left: 0;
      }

      .eyeimg {
        display: flex;
        align-items: center;
        // justify-content: flex-end;
        margin-left: auto;
        margin-right: 0.1rem;

        img {
          // border-radius: 100%;
          // display: block;
          width: 0.9rem;
          height: 0.7rem;
        }
      }
    }
  }

  .four-pard {
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-bottom: 1px solid rgb(238, 238, 238);

    .btn {
      background: #628808;
      color: white;
      font-size: 0.34rem;
      border-radius: 4px;
      width: 47%;
      height: 0.83rem;
      margin: 0 0.1rem;
    }

    :nth-child(2) {
      background: #724ed6;
    }
  }

  .second-pard {
    background: white;

    ul {
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgb(238, 238, 238);
      cursor: pointer;
      margin: auto;

      li {
        display: flex;
        align-items: center;
        height: 1.1rem;
      }

      :nth-child(1) img {
        // display: block;
        margin: auto 0.3rem;
        width: 0.7rem;
        height: 0.7rem;
      }

      :nth-child(3) {
        display: flex;
        justify-content: flex-end;
        margin-left: auto;
        margin-right: 0.4rem;

        img {
          display: block;
          width: 0.46rem;
        }
      }
    }
  }

  .third-part {
    display: flex;
    justify-content: center;
    padding-top: 0.14rem;
    margin-bottom: 1.3rem;

    .btn {
      border-radius: 4px;
      width: 96%;
      height: 0.85rem;
      font-size: 0.34rem;
      background: #628808;
      color: white;
    }

    .btn:hover {
      background: #628808;
    }
  }
}
</style>  